/**
 * @generated SignedSource<<d8e3b1fcc35af7c60f5f151bcdab0bd5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type parentLink_buyerLead$data = {
  readonly id: string;
  readonly lot: {
    readonly id: string;
  };
  readonly " $fragmentType": "parentLink_buyerLead";
};
export type parentLink_buyerLead$key = {
  readonly " $data"?: parentLink_buyerLead$data;
  readonly " $fragmentSpreads": FragmentRefs<"parentLink_buyerLead">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "parentLink_buyerLead",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Lot",
      "kind": "LinkedField",
      "name": "lot",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "BuyerLead",
  "abstractKey": null
};
})();

(node as any).hash = "f16bef5a87deb407c80774e43bf261c3";

export default node;
